import { GameMedia } from 'functions/src/types/firestore/Game/GameMedia';
import { useEffect, useRef, useState } from 'react';
import { GliderMethods } from 'react-glider/dist/types';
import { useMedia } from 'src/contexts/MediaContext';
import { useVisible } from './useVisible';

export const useMediaControls = (defaultMediaIndex: number) => {
  const [pauseAutoplay, setPauseAutoplay] = useState(false);

  const { media, activeMediaIndex, setActiveMediaIndex } = useMedia();
  const gliderRef = useRef<GliderMethods & { slides: HTMLDivElement[] }>(null);
  const visibleRef = useRef<Element | null>(null);
  const isVisible = useVisible(visibleRef);
  const intersectionRef = useRef<Element | undefined>(undefined);

  useEffect(() => {
    setActiveMediaIndex(defaultMediaIndex);
    gliderRef.current?.scrollItem(defaultMediaIndex);
  }, [defaultMediaIndex, setActiveMediaIndex]);
  const activeMedia: GameMedia = media[Number(activeMediaIndex)];

  const nextSlide = () => {
    if (gliderRef.current) {
      setActiveMediaIndex((prev) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nextSlideIndex = (prev + 1) % gliderRef.current!.slides.length;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        gliderRef.current!.scrollItem(nextSlideIndex);
        return nextSlideIndex;
      });
    }
  };

  const prevSlide = () => {
    if (gliderRef.current) {
      setActiveMediaIndex((prev) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const mediaLength = gliderRef.current!.slides.length;
        const prevSlideIndex = (prev + mediaLength - 1) % mediaLength;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        gliderRef.current!.scrollItem(prevSlideIndex);
        return prevSlideIndex;
      });
    }
  };

  useEffect(() => {
    const leftNavArrow = document.querySelector('.glider-prev');
    const rightNavArrow = document.querySelector('.glider-next');
    leftNavArrow?.addEventListener('click', prevSlide);
    rightNavArrow?.addEventListener('click', nextSlide);
    return () => {
      leftNavArrow?.removeEventListener('click', prevSlide);
      rightNavArrow?.removeEventListener('click', nextSlide);
    };
  });

  const onVideoEnd = (pause: boolean) => {
    if (!pause) {
      nextSlide();
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (activeMedia.type === 'image') {
        nextSlide();
      }
    }, 5000);

    return () => {
      return clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMedia.type]);

  return {
    activeMedia,
    onVideoEnd,
    pauseAutoplay,
    setPauseAutoplay,
    isVisible,
    visibleRef,
    intersectionRef,
    gliderRef,
  };
};
